import React from "react";
import { Box, Typography, Grid, Paper, Fade, Grow } from "@mui/material";
import { School } from "@mui/icons-material";

function EducationSection() {
  const education = [
    {
      title: "Associates Degree",
      description: "Texas State Technical College",
    },
    {
      title: "Java Development",
      description:
        "Professional certification in Java programming and development",
    },
    {
      title: "Mobile App Development",
      description: "Certified in mobile application development and design",
    },
  ];

  return (
    <Box sx={{ mt: 8 }}>
      <Fade in timeout={1900}>
        <Typography
          variant="h4"
          component="h3"
          textAlign="center"
          gutterBottom
          sx={{
            fontWeight: 600,
            mb: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <School sx={{ color: "#0066CC" }} />
          Education
        </Typography>
      </Fade>

      <Grow in timeout={2000}>
        <Paper
          elevation={2}
          sx={{
            p: 4,
            textAlign: "center",
            borderRadius: 3,
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          }}
        >
          <Grid container spacing={3} justifyContent="center">
            {education.map((item, index) => (
              <Grid item xs={12} sm={4} key={item.title}>
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontWeight: 600 }}
                  >
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Grow>
    </Box>
  );
}

export default EducationSection;
